import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Pagination from "../../../components/_Pagination";
import Loading from "./Loading";
import Item from "./Item";
import { load } from "../../../actions/notes";

const mapStateToProps = ({ notes, user }, { match }) => {
  const lesson = notes.lessons[match.params.id];
  if (!lesson) {
    return { permissions: user.permissions || [] };
  }

  return {
    permissions: user.permissions || [],
    page: lesson.page,
    itemsPerPage: lesson.itemsPerPage,
    list: lesson.list,
    count: lesson.count,
    isLoaded: lesson.isLoaded,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadContent: load,
    },
    dispatch
  );

class Notes extends React.Component {
  componentDidMount() {
    const { match, page, loadContent } = this.props;
    loadContent("lessons", match.params.id, page || 1);
  }

  render() {
    if (!this.props.permissions.includes("LESSON_MY_NOTES_LIST")) {
      return null;
    }

    const {
      page,
      itemsPerPage,
      list,
      count,
      isLoaded,
      match,
      loadContent,
    } = this.props;
    const { id: lessonId } = match.params;

    return (
      <div style={{ position: "relative" }}>
        {!isLoaded && <Loading />}
        {list && (
          <React.Fragment>
            <div className="tiles">
              {list.map(({ id, text }) => (
                <Item
                  key={id}
                  id={id}
                  text={text}
                  onDelete={() => loadContent("lessons", lessonId, 1)}
                  actionType="update"
                  permissions={this.props.permissions}
                />
              ))}
              <Item
                key={lessonId}
                id={lessonId}
                text=""
                onDelete={() => loadContent("lessons", lessonId, 1)}
                actionType="add"
                permissions={this.props.permissions}
                disabled={
                  !this.props.permissions.includes("LESSON_MY_NOTES_ADD")
                }
              />
            </div>
            <Pagination
              activePage={page}
              itemsPerPage={itemsPerPage}
              totalItems={count}
              onChange={(destinationPage) =>
                loadContent("lessons", lessonId, destinationPage)
              }
            />
            <div className="clear10" />
          </React.Fragment>
        )}
      </div>
    );
  }
}

Notes.propTypes = {
  permissions: PropTypes.arrayOf(PropTypes.string).isRequired,
  match: PropTypes.objectOf(PropTypes.any),
  page: PropTypes.number,
  itemsPerPage: PropTypes.number,
  list: PropTypes.arrayOf(PropTypes.any),
  count: PropTypes.number,
  isLoaded: PropTypes.bool,
  loadContent: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Notes);



// WEBPACK FOOTER //
// ./src/views/_Lessons/Notes/Lesson.js